import { render } from "./PickupBoxForm.vue?vue&type=template&id=364cfb59&ts=true"
import script from "./PickupBoxForm.vue?vue&type=script&lang=ts"
export * from "./PickupBoxForm.vue?vue&type=script&lang=ts"

import "./PickupBoxForm.vue?vue&type=style&index=0&id=364cfb59&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__